import { Apikeypopup, Promptalert } from "components";
import { getDataFromLocalStorage } from "utils/helpers";
import { useSelector } from "react-redux";
import { icons } from "utils/constants";
import AppRoute from "routes/AppRoute";
import AuthRoute from "routes/AuthRoute";
import {
  RainbowKitProvider,
  getDefaultWallets,
  lightTheme,
  darkTheme,
  // Theme,
} from "@rainbow-me/rainbowkit";
import { configureChains, createConfig, WagmiConfig } from "wagmi";
import { alchemyProvider } from "wagmi/providers/alchemy";
import { mainnet, polygon } from "wagmi/chains";
import "@rainbow-me/rainbowkit/styles.css";
import "./App.css";
// import { useEffect } from "react";
// import { setIsDarkMode } from "store/globalSlice";

const { chains, publicClient } = configureChains(
  [mainnet, polygon],
  [
    alchemyProvider({
      apiKey: process.env.REACT_APP_ALCHEMY_API_KEY,
    }),
  ]
);
const { connectors } = getDefaultWallets({
  appName: "UNODE",
  chains,
  projectId: process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID,
});
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
});
const CustomAvatar = ({ size }) => {
  return <img src={icons.metamask} alt="logo" width={size} height={size} />;
};

// const myCustomDarkTheme: Theme = {
//   blurs: {
//     modalOverlay: "2px",
//   },
//   colors: {
//     accentColor: "#4b4d6c",
//     accentColorForeground: "#FFFFFF",
//     actionButtonBorder: "#FFFFFF",
//     actionButtonBorderMobile: "#FFFFFF",
//     actionButtonSecondaryBackground: "#808080",
//     closeButton: "#FFFFFF",
//     closeButtonBackground: "#4b4d6c",
//     connectButtonBackground: "#282b4e",
//     connectButtonBackgroundError: "#FF0000",
//     connectButtonInnerBackground: "#4b4d6c",
//     connectButtonText: "#FFFFFF",
//     connectButtonTextError: "#FFFFFF",
//     connectionIndicator: "#00FF00",
//     downloadBottomCardBackground: "#000080",
//     downloadTopCardBackground: "#000080",
//     error: "#FF0000",
//     generalBorder: "#FFFFFF",
//     generalBorderDim: "#808080",
//     menuItemBackground: "#4b4d6c",
//     modalBackdrop: "#000000e3",
//     modalBackground: "#282b4e",
//     modalBorder: "#282b4e",
//     modalText: "#FFFFFF",
//     modalTextDim: "#808080",
//     modalTextSecondary: "#000000",
//     profileAction: "#4b4d6c",
//     profileActionHover: "#808080",
//     profileForeground: "#282b4e",
//     selectedOptionBorder: "#4b4d6c",
//     standby: "#808080",
//   },
//   fonts: {
//     body: "Arial, sans-serif",
//   },
//   radii: {
//     actionButton: "10px",
//     connectButton: "10px",
//     menuButton: "10px",
//     modal: "10px",
//     modalMobile: "10px",
//   },
//   shadows: {
//     connectButton: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//     dialog: "0px 4px 8px rgba(0, 0, 0, 0.1)",
//     profileDetailsAction: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//     selectedOption: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//     selectedWallet: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//     walletLogo: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//   },
// };

const App = () => {
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  const isAuth = getDataFromLocalStorage("access_token");

  let theme = localStorage.getItem("theme");
  const body = document.querySelector("body");
  if (theme === "dark") {
    body.classList.add("dark-theme");
    body.classList.remove("light-theme");
  } else {
    body.classList.remove("dark-theme");
    body.classList.add("light-theme");
  }

  return (
    <div className={`App vh-100 ${isDarkMode ? "dark-mode" : ""}`}>
      <WagmiConfig config={wagmiConfig}>
        <RainbowKitProvider
          coolMode
          chains={chains}
          avatar={CustomAvatar}
          theme={isDarkMode ? darkTheme() : lightTheme()}
          // theme={isDarkMode ? myCustomDarkTheme : lightTheme()}
        >
          <Apikeypopup />
          <Promptalert />
          {isAuth ? <AppRoute /> : <AuthRoute />}
        </RainbowKitProvider>
      </WagmiConfig>
    </div>
  );
};

export default App;
